import httpClient from '@core/http/httpClient';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { getPathPayload } from '@hwm/ui-lib';
import { AxiosResponse } from 'axios';
import { applicationPaths } from '@core/http/applicationPaths';
import { AccountModel } from '@shared/models';

const fetchSubAccounts = createAsyncThunk(
  `accounts/fetchSubaccounts`,
  async (params: getPathPayload<typeof applicationPaths.accounts.subAccounts>) => {
    const response: AxiosResponse<AccountModel[]> = await httpClient.get(applicationPaths.accounts.subAccounts(params));

    return response.data;
  }
);

const fetchById = createAsyncThunk(
  `accounts/fetchById`,
  async (params: getPathPayload<typeof applicationPaths.accounts.getAccountById>) => {
    const response: AxiosResponse<AccountModel> = await httpClient.get(
      applicationPaths.accounts.getAccountById(params)
    );

    return response.data;
  }
);

export const accountsThunks = { fetchSubAccounts, fetchById };
